import React, { useState } from "react";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import { api } from "../../../../api/settings";
import { ClipLoader, ScaleLoader } from "react-spinners";
import Pagination from "../../../../components/pagination/Pagination";
import { format } from "date-fns";

const Credentials = () => {
  const user = JSON.parse(window.sessionStorage.getItem("user"));
  const orgId = user?.org?.id;


  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [copiedField, setCopiedField] = useState(null);
  const [loading, setLoading] = useState(false);


  const handleCopy = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopiedField(null), 2000);
    } catch (err) {
      toast.error("Failed to copy");
    }
  };


  const {
    data: apis,
    isLoading,
    refetch,
  } = useQuery(
    ["all-apis", search, perPage, currentPage],
    async () => {
      const response = await api.getApiCredentials({
        orgId,
        search,
        perPage,
        currentPage,
      });

      return response.data;
    },
    {
      cacheTime: 100,
      staleTime: 100,
    },
    {
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );

  const createNewCredentials = async () => {
    setLoading(true);
    try {
      const response = await api.createApiCredentials({
        orgId,
      });
      toast.success(
        response?.message || "New API credentials created successfully"
      );
      refetch()
    } catch (error) {
      toast.error("Failed to create new credentials");
    } finally {
      setLoading(false);
    }
  };

 
  

  return (
    <div className="">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-xl font-bold text-gray-900">API Credentials</h1>
          <p className="text-gray text-base-600 mt-1">Manage your API keys and secrets</p>
        </div>

        <button
          onClick={createNewCredentials}
          disabled={loading}
          className="flex items-center gap-2 px-4 py-2 bg-customBlue text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
        >
          {loading ? (
            <ClipLoader className="w-4 h-4 animate-spin" />
          ) : (
            <i class="bi bi-plus w-4 h-4"></i>
          )}
          Create API Credentials
        </button>
      </div>


      <div className="p-4 md:p-6 overflow-auto ">
        <div className="bg-white p-3 rounded-lg shadow-sm">
          {isLoading ? (
            <div className="mt-10 flex justify-center items-center">
              <ScaleLoader color="#FF9100" />
            </div>
          ) : (
            <div className="mt-4 ">
              <div className="">
                <table className="table-container">
                  <thead className="table-header">
                    <tr>
                      <th className="table-head text-left">API Key</th>
                      <th className="table-head">API Secret</th>
                      <th className="table-head">Status</th>
                      <th className="table-head">Created</th>
                      {/* <th className="table-head">Last Updated</th> */}
                    </tr>
                  </thead>

                  <tbody className="table-body text-xs">
                    {apis?.length > 0 ? (
                      apis.map((cred) => (
                        <tr key={cred.id}>
                          <td className="table-data text-left">
                            <div className="flex items-center gap-2">
                              <i className=" bi bi-key w-4 h-4 text-gray-400"> </i>
                              <code className="text-sm font-mono bg-gray-50 px-2 py-1 rounded">
                                {cred.apiKey.slice(0, 8)}...
                                {cred.apiKey.slice(-8)}
                              </code>
                              <button
                                onClick={() =>
                                  handleCopy(cred.apiKey, `key-${cred.id}`)
                                }
                                className="p-1 hover:bg-gray-100 rounded-md transition-colors"
                              >
                                {copiedField === `key-${cred.id}` ? (
                                  <i class="bi bi-check w-4 h-4 text-green-500"></i>
                                ) : (
                                  <i class="bi bi-copy w-4 h-4 text-gray-400"></i>
                                )}
                              </button>
                            </div>
                          </td>
                          <td className="table-data text-left">
                            <div className="flex items-center gap-2">
                              <code className="text-sm font-mono bg-gray-50 px-2 py-1 rounded">
                                {cred.apiSecret.slice(0, 8)}...
                                {cred.apiSecret.slice(-8)}
                              </code>
                              <button
                                onClick={() =>
                                  handleCopy(
                                    cred.apiSecret,
                                    `secret-${cred.id}`
                                  )
                                }
                                className="p-1 hover:bg-gray-100 rounded-md transition-colors"
                              >
                                {copiedField === `secret-${cred.id}` ? (
                                  <i class="bi bi-check w-4 h-4 text-green-500"></i>
                                ) : (
                                  <i class="bi bi-copy w-4 h-4 text-gray-400"></i>
                                  //   <Copy className="w-4 h-4 text-gray-400" />
                                )}
                              </button>
                            </div>
                          </td>
                          <td className="table-data text-left">
                            <span className="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800 capitalize">
                              {cred.status}
                            </span>
                          </td>

                          <td className="table-data text-sm text-gray-600">
                            {format(new Date(cred.createdAt), "MMM d, yyyy")}
                          </td>
                          {/* <td className="table-data ">
                          {moment(api.updatedAt).format(
                            "YYYY/MM/DD, h:mm a"
                          )}
                        </td> */}

                         
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="table-data" colSpan="12">
                          <p className="text-center">No Data Available</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {apis?.length > 10 &&  <section className={`mt-1 px-3 rouded-lg bg-white`}>
            <Pagination
              data={apis?.meta}
              perPage={perPage}
              pageNo={currentPage}
              setPageNo={setCurrentPage}
              setPerPage={setPerPage}
            />
          </section>}
         
        </div>
      </div>
    </div>
  );
};

export default Credentials;
